import { FuelDivider, FuelIcon, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { ITruckerProfileProps } from 'interfaces/profile.interface';
import React from 'react';
import * as Styled from './styled';

const Body = ({ evaluation, journey }: ITruckerProfileProps) => (
  <FuelFlex defaultProps={{ alignItems: 'center', justifyContent: 'center', gap: 'km6' }}>
    <FuelFlex defaultProps={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <FuelTypography size="body-lg" color="neutral-strong" weight="bold" data-testid="total-travels">
        {journey?.total ? journey?.total : 0}
      </FuelTypography>
      <FuelTypography size="body-sm" color="neutral-default" weight="medium">
        {journey?.total === 1 ? `viagem feita` : `viagens feitas`}
      </FuelTypography>
    </FuelFlex>
    <FuelFlex defaultProps={{ height: '60px' }}>
      <FuelDivider orientation="vertical" />
    </FuelFlex>
    <FuelFlex defaultProps={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <FuelTypography size="body-lg" color="neutral-strong" weight="bold" data-testid="final-grade">
        {evaluation?.grade}
        <Styled.StarWrapper>
          <FuelIcon name="star" iconStyle="filled" size="tiny" data-testid="rating-icon" />
        </Styled.StarWrapper>
      </FuelTypography>
      <FuelTypography size="body-sm" color="neutral-default" weight="medium">
        {evaluation?.total} {evaluation?.total === 1 ? `avaliação` : `avaliações`}
      </FuelTypography>
    </FuelFlex>
  </FuelFlex>
);

export default Body;
